import { assert, randomUUID, toBase64 } from "./util";
import {
  AuthRxMessage,
  AuthRxOp,
  AuthTxMessage,
  AuthTxValue,
} from "./auth_api";
import { LoginParams } from "./bindings/LoginParams";

const url_api_base = `${location.protocol}//${location.host}/api`;
// @ts-ignore
const worker_url = `/js/auth-${HASH}.js`;

const worker = new Worker(worker_url, { type: "module" });
const hmac = { name: "HMAC", hash: "SHA-256" };

let _uuid = localStorage.getItem("uuid");
export function uuid(): string {
  if (_uuid === null) {
    _uuid = randomUUID();
    localStorage.setItem("uuid", _uuid);
  }
  return _uuid;
}
function send(msg: AuthRxMessage) {
  worker.postMessage(msg);
}
const pending: Map<
  string,
  {
    resolve: (v: AuthTxValue) => void;
    reject: (s: string) => void;
    progress: (v: any) => void;
  }
> = new Map();
worker.onmessage = (e) => {
  const { id, val }: AuthTxMessage = e.data;
  const { resolve, reject, progress } = pending.get(id);
  switch (val.result) {
    case "ok": {
      resolve(val.value);
      break;
    }
    case "err": {
      reject(val.message);
      break;
    }
    case "progress":
      if (progress !== undefined) {
        progress(val.value);
      }
      return;
  }
  pending.delete(id);
};
async function auth_op(
  op: AuthRxOp,
  progress?: (val: any) => void,
): Promise<AuthTxValue> {
  return new Promise((resolve, reject) => {
    const id = uuid();
    pending.set(id, { resolve, reject, progress });
    send({ id, op });
  });
}
export async function login_srp<Login>(
  params: LoginParams,
  progress?: (s: string) => void,
): Promise<Login> {
  const r = await auth_op(
    {
      type: "login",
      ident: params.ident,
      pass: params.password,
    },
    progress,
  );
  assert(r.type === "login");
  const { info, key } = r;

  async function sign(body: Uint8Array) {
    let b = await window.crypto.subtle.sign(hmac, key, body.buffer as BufferSource);
    return toBase64(new Uint8Array(b));
  }
  const f: AuthFuncs = {
    sign,
  };
  const arg = { ...info, f };
  return arg;
}
export async function register_str(
  ident: string,
  pass: string,
): Promise<string> {
  const r = await auth_op({
    type: "register",
    ident,
    pass,
  });
  assert(r.type === "register");
  return toBase64(r.data);
}

export type SignFunc = (body: Uint8Array) => Promise<string>;
export interface AuthFuncs {
  sign: SignFunc;
}
export async function logout(): Promise<void> {
  const response = await check_fetch(`${url_api_base}/logout`, {
    method: "POST",
    credentials: "include",
  });
}

export async function check_fetch(path: string, options?: RequestInit) {
  const response = await fetch(path, options);

  if (response.ok) {
    return response;
  }
  let text = await response.text();
  console.error(path, response.status, options, text);

  throw {
    status: response.status,
    text,
  };
}
